/* eslint-disable */
export default {
  header: 'Désactiver le suivi des erreurs',
  content:
    'La désactivation du mode de suivi des erreurs supprimera tous les journaux d’erreurs actuels. Voulez-vous continuer ?',
  confirm: 'Désactiver',
  cancel: 'Annuler',
} as const;

// @key: @#@"header"@#@ @source: @#@"Turn off error tracking"@#@
// @key: @#@"content"@#@ @source: @#@"Turning off error tracking mode will delete any current error logs. Do you wish to continue?"@#@
// @key: @#@"confirm"@#@ @source: @#@"Turn off"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
